import React from 'react';
import { Modal } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ITrButton, ITrInterfaces, tB, tI } from '../translate';

const { confirm } = Modal;

type ShowConfirm = {
    title?: ITrInterfaces;
    content?: ITrInterfaces;
    onOk?: () => void;
    onCancel?: () => void;
    okText?: ITrButton;
    cancelText?: ITrButton;
};
export const showConfirm = ({
    title = 'Confirm',
    content,
    cancelText = 'Cancel',
    okText = 'Confirm',
    onCancel,
    onOk,
}: ShowConfirm): void => {
    confirm({
        title: title ? tI(title) : undefined,
        content: content ? tI(content) : undefined,
        type: 'confirm',
        cancelText: tB(cancelText),
        okText: tB(okText),
        icon: <QuestionCircleOutlined />,
        onOk() {
            onOk && onOk();
        },
        onCancel() {
            onCancel && onCancel();
        },
        wrapClassName: 'modal',
    });
};
